import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@gasbuddy/react-components';

import styles from './styles.css';

export default function BPLoader({ children, ...rest }) {
  return (<Loader className={styles.cetner} {...rest}>{children}</Loader>);
}

BPLoader.propTypes = {
  children: PropTypes.node.isRequired,
};
